function initMainProduct() {
  const input = document.getElementById("pincode-input");
  const message = document.getElementById("pincode-message");
  const checkBtn = document.getElementById("check-button");
  const clearBtn = document.getElementById("clear-button");

  const API_URL = "https://delhivery-pincode-proxyy.vercel.app/api/delhivery";

  // 🧮 Helper functions
  const isValidIndianPincode = (pin) => /^[1-9][0-9]{5}$/.test(pin);
  const showMessage = (text, color = "inherit") => {
    message.innerHTML = text;
    message.style.color = color;
  };

  const showDefaultMessage = () => {
    showMessage("✅ Please enter your Pin code to check the delivery timeline", "green");
  };

  // 🌀 Loading animation
  const showLoading = () => {
    showMessage(`<span style="color:#666;">⏳ Checking availability...</span>`);
  };

  // 💡 Initialize buttons
  window.addEventListener("DOMContentLoaded", () => {
    showDefaultMessage();
    clearBtn.style.display = "none";
    checkBtn.style.display = "inline-block";
  });

  // 🧾 On Check click
  checkBtn.addEventListener("click", async () => {
    const pincode = input.value.trim();

    if (!pincode) return showDefaultMessage();
    if (!isValidIndianPincode(pincode))
      return showMessage("❌ Please enter a valid 6-digit Indian pincode.", "red");

    showLoading();

    try {
      const response = await fetch(`${API_URL}?pin=${pincode}`);
      const data = await response.json();

      if (data.available) {
        // ✅ Show city & state from backend
        showMessage(
          `✅ Delivery available in <strong>${data.city}, ${data.state}</strong>. Estimated arrival: 3–5 days.`,
          "green"
        );
      } else {
        showMessage(
          `✅ Please enter your Pin code to check the delivery timeline`,
    "green"
        );
      }

      checkBtn.style.display = "none";
      clearBtn.style.display = "inline-block";
    } catch (err) {
      console.error("Delhivery check failed:", err);
      showMessage("⚠️ Something went wrong. Please try again later.", "#d32f2f");
    }
  });

  // 🧹 On Clear click
  clearBtn.addEventListener("click", () => {
    input.value = "";
    showDefaultMessage();
    clearBtn.style.display = "none";
    checkBtn.style.display = "inline-block";
  });
}

document.addEventListener("DOMContentLoaded", initMainProduct);
